// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3104 ? "3975359d" : chunkId) + "." + {"3104":"5ce6a8673dc71a37","7111":"e51da89f2ce75221"}[chunkId] + ".js";
};